import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { UniversitiesStore } from '../../data-access/+state/universities.store';
import { FilterPillComponent } from '@web/shared/ui';
import { UniversityMultiOptionQueryParam } from '@uc/web/shared/data-models';
import { generateLink } from '../../utils/url.utils';
import { UniversitySearchScrollerService } from '../../services/university-search-scroller.service';

@Component({
	selector: 'uc-applied-filters-bar',
	imports: [CommonModule, FilterPillComponent],
	templateUrl: './applied-filters-bar.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppliedFiltersBarComponent {
	readonly store = inject(UniversitiesStore);
	private _location = inject(Location);
	private _scrollSrv = inject(UniversitySearchScrollerService);

	removePill(urlKey: string, urlValue: string) {
		const key = urlKey as UniversityMultiOptionQueryParam;
		this.store.updateQueryParams(key, urlValue, false);

		const baseUrl = `/universities/${this.store.product()}`;
		const url = generateLink(baseUrl, this.store.queryParams());

		this._location.go(url);
		this._scrollSrv.scroll();
	}
}
